import { placementLabel } from "../../util/adAnalytics";
import AdsAppPreview from "./AdsAppPreview.jsx";

const AdsSlotPreview = ({ imageUrl, placement = "SPONSOR_SECTION", title = "" }) => {
    if (!imageUrl) {
        return null;
    }
    const isLogo = placement === "SPONSOR_SECTION";
    const where = isLogo ? "the logo strip" : placementLabel(placement);

    return (
        <aside className="ads-slot-preview" data-testid="ads-slot-preview">
            <p className="ads-slot-kicker">Preview</p>
            <h3>How members will see this</h3>
            <p className="ads-hint">This is {where} in the app. Plus clubs only show the logo strip. Open the Preview tab to flip through Home, Events, and Event Details.</p>
            <AdsAppPreview
                compact
                clubName="Your club"
                isFreePlan
                draft={{ imageUrl, placement, title }}
            />
        </aside>
    );
};

export default AdsSlotPreview;
